export const OBSERVER_KEY_TEMPLATE_VARIABLE_REPLACEMENT_QUALIFIER_START = "<<";
export const OBSERVER_KEY_TEMPLATE_VARIABLE_REPLACEMENT_QUALIFIER_END = ">>";